import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import {
  Answer,
  AnswerTable,
  ObjectDates,
  RadicadosPorFecha
} from '@app/shared';

@Injectable()
export class ResponseOfDataService {
  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) {}


   getRadicatesByRangeDate(dates: ObjectDates): Promise<RadicadosPorFecha[]> {
    return new Promise((resolve, reject) => {
      this.http.post<RadicadosPorFecha[]>(this.api.get('radicationUtilities'), dates).subscribe(
        radicates => {
          if(radicates.length > 0){
            resolve(radicates);
          } else {
            this.toastr.warning('No ha radicados disponibles para las fechas ingresadas', 'Alerta');
            resolve(null);
          }
          },
          err => {
            reject(err);
          }
        );
    });
  }

  addAnswer(answer: Answer): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.post<boolean>(this.api.get('documentAnswer'), answer).subscribe(
        (_resp) => {
          this.toastr.success('Operación exitosa', 'respuesta agregada correctamente');
          resolve(true);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getAllAnswer(id: number): Observable<AnswerTable[]> {
    return new Observable(obs => {
      this.http.get<AnswerTable[]>(this.api.get('documentAnswer', [id])).subscribe(
        res => {
          obs.next(res);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  deleteAnswer(id: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.delete<boolean>(this.api.get('documentAnswer', [id])).subscribe(
        (_resp) => {
          this.toastr.success('Operación exitosa', 'Respuesta eliminada correctamente');
          resolve(true);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }


  downloadAnswer(idDocumento: number): Observable<any> {
    return new Observable(obs => {
      this.http
        .skipErrorHandler()
        .get(this.api.get('docsInstance', [idDocumento]), {
          observe: 'response'
        })
        .subscribe(
          res => {
            if (res.status === 201 || res.status === 200) {
              obs.next(res.body);
            }
          },
          err => {
            if (err.status !== 401 && err.status !== 403) {
              this.toastr.error(err.error['message'], 'Fallo de descarga');
            }
            obs.error(err);
          }
        );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/forms/shared/response-of/shared/response-of-data.service.ts